module.exports = __webpack_public_path__ + "static/assets/ab1aa02438c4970ec7010ef055a6695c.png";